export default {"src":"/login-app/[GIT_HASH]/_next/static/media/pagerduty.cf3a6f86.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};